<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :table-data="getData"
          :total-data="totalRows"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerForm"
          :redirect-detail="true"
          :show-add-button="false"
          :search-by-lead-date="true"
          caption="<i class='fa fa-align-justify'></i> Leads Listing"
          addButton="Tambah Customer"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "leads",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leads: [],
      customerForm: interfaces.employee,
      loading: true,
      loadingSubmit: false,
      totalRows: "",
      fields: [
        {
          key: "lead_code",
          label: "Lead Code",
          sortable: true,
          class: "width-150",
          filterByFormatted: true,
        },
        {
          key: "leads_detail",
          label: "Nama Konsumen",
          class: "width-200",
          sortable: true,
          filterByFormatted: true,
        },
        {
          key: "address",
          label: "Alamat",
          class: "width-250",
          sortable: false,
          filterByFormatted: false,
        },
        {
          key: "ktp_address",
          label: "Alamat KTP",
          class: "width-250",

          sortable: false,
          filterByFormatted: false,
        },
        {
          key: "lead_date_inserted",
          label: "Tanggal Input",
          sortable: false,
          class: "width-150",

          filterByFormatted: false,
        },
        {
          key: "employee_name",
          label: "Di input oleh",
          class: "width-150",

          sortable: false,
          filterByFormatted: false,
        },
        { key: "action", class: "text-center width-80" },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    getData: function (ctx) {
      this.loading = true;
      let response = axios.post("web/leads/all", ctx);
      return response
        .then((data) => {
          const items = data.data.data;
          this.totalRows = data.data.total_rows;
          this.loading = false;
          return items;
        })
        .catch((error) => {
          this.expired(error);
          this.loading = false;
          return [];
        });
    },
    editForm: function () {},
    resetForm: function () {},
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    //this.init();
  },
};
</script>